module.exports = __webpack_public_path__ + "static/bridgette-wallace-c150f7ee937c67f7aada4874be90b34c.jpg";